import * as React from 'react';
import { SocialAuthCallback } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';

import theme from '../../theme/theme';
import '../../theme/variables.css';
import Head from '@websky/core/src/Head';

const SearchFormComponent: React.FC = () => {
	return (
		<ThemeProvider value={theme}>
			<Head />
			<SocialAuthCallback />
		</ThemeProvider>
	);
};

export default SearchFormComponent;
